/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'my idicare': {
    width: 16,
    height: 16,
    viewBox: '0 0 56.19 43.48',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M0 34.32h10.7L25.73 1.27l16.33 41 6.21-12.08h7.92" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/my idicare.js